import { useAuthStore } from '../stores/authStore';
import { DashboardPage } from './DashboardPage';
import { DashboardSkeleton } from '../components/common/Skeleton';

export default function DashboardRouter() {
  const business = useAuthStore(s => s.business);
  const loading = useAuthStore(s => s.loading);

  if (loading || !business) return <DashboardSkeleton />;

  return <DashboardPage />;
}
